import { config } from 'src/config';

const { BOR_VIDEO_SUBMISSION_EMAIL } = config;
export const buildSubmitYourVideoEmail = (shareVideoUrl: string): string =>
  `mailto:${BOR_VIDEO_SUBMISSION_EMAIL}
    ?subject=Hello Ring! Here's my video for Best of Ring.
    &body=Be sure to include a brief description of what happens, whether it's a safety issue, ` +
  `a funny moment, or something totally unexpected.%0D%0AOur team will review it and reach out with ` +
  `more details if necessary.%0D%0A%0D%0A${shareVideoUrl}`;
